import { api } from "@/api"
import { queryClient } from "@/queryClient"

export type EditCategoryQuery = {
  name: string
  parentCategoryId: string | null
  color: string | null
}

export const updateCategory = async (
  categoryId: string,
  params: EditCategoryQuery
) => {
  await api.put(`/products/categories/${categoryId}/`, {
    body: params,
  })
  queryClient.invalidateQueries({
    queryKey: [BASE_CATEGORIES_QUERY_KEY],
  })
  return
}
